var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTravellingHs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTravellingHS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.5594149,6.16747558 C14.5205667,5.87677632 14.6565353,5.4891773 14.8702001,5.27599784 L15.5888911,4.59769956 L17.4341787,2.87288392 C17.4536028,2.85350397 17.4730269,2.83412402 17.492451,2.81474407 C18.0363252,2.23334554 18.2499901,0.973648734 17.5895714,0.353490305 C16.9485767,-0.266668125 15.6860115,0.00465118822 15.1421373,0.586049716 L12.7335513,3.18296314 C12.5393105,3.3961426 12.1314048,3.53180226 11.8400436,3.49304235 L1.66182566,2.03954603 C1.37046446,2.00078613 0.981982854,2.15582574 0.807166133,2.3690052 L0.107899249,3.22172304 C-0.0863415524,3.45428245 -0.00864523194,3.70622181 0.26329189,3.82250152 L8.53795002,6.96205357 C8.80988714,7.05895332 8.86815938,7.33027264 8.67391858,7.5434521 L5.11931192,11.3225425 C5.08046376,11.3419225 5.02219152,11.3419225 4.98334336,11.3419225 L1.00140693,11.3806824 C0.846014293,11.3806824 0.710045732,11.4969621 0.690621652,11.6520017 L0.496380851,12.6403792 C0.476956771,12.7760388 0.554653091,12.9504584 0.690621652,12.9892183 L3.60423367,14.0744956 C3.74020223,14.1326354 3.89559487,14.287675 3.93444303,14.4233347 L5.02219152,17.3303273 C5.08046376,17.465987 5.2358564,17.5628867 5.37182496,17.5241268 L6.36245305,17.3303273 C6.49842161,17.3109474 6.61496609,17.1559078 6.63439017,17.0202481 L6.67323833,13.0279782 C6.67323833,12.9892183 6.67323833,12.9504584 6.69266241,12.8923185 L8.82931122,10.8961836 L10.4997821,9.32640758 C10.713447,9.13260807 10.96596,9.19074792 11.0825045,9.46206724 L14.2292055,17.7373063 C14.3263259,18.0086256 14.598263,18.0861454 14.831352,17.8923459 L15.6860115,17.1946677 C15.8996764,17.0202481 16.055069,16.6326491 16.0162209,16.3419498 L14.5594149,6.16747558 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-header4-Final",
    transform: "translate(-705.000000, -1078.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    transform: "translate(670.000000, 173.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Travelling-v1",
    transform: "translate(27.000000, 894.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(8.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icTravellingHS",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTravellingHs);
export default __webpack_public_path__ + "static/media/icTravellingHS.b3106c4bf651cd44b388d0acbc0ac8d3.svg";
export { ForwardRef as ReactComponent };